import i18n from '@dms/i18n';

import {VEHICLE_FORM_EVENTS} from '../../core/machine/constants/VEHICLE_FORM_EVENTS';
import {MechanicalReplacementServiceIntervals} from '../../core/types/RentalVehicle';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

interface ReplacementAfterMonthsInputProps {
  name: MechanicalReplacementServiceIntervals;
}

/**
 * Numeric input component for defining the time interval (in months) after which a vehicle component should be replaced.
 * Used in service interval tracking to set the replacement frequency based on time.
 * Automatically calculates the next replacement date when changed.
 *
 * @param props.name - The component name (e.g., 'engineOil', 'gearboxOil', 'timingBelt')
 */
export function ReplacementAfterMonthsInput(props: ReplacementAfterMonthsInputProps) {
  const {sendMachineEvent} = useVehicleFormContext();

  const handleChange = (value: number | null) => {
    sendMachineEvent({
      type: VEHICLE_FORM_EVENTS.LAST_REPLACEMENT_DATE_INTERVAL_CHANGED,
      name: props.name,
      value,
    });
  };

  return (
    <Field
      type="number"
      name={`serviceIntervals.${props.name}.replacementAfterMonths`}
      label={i18n.t('entity.vehicle.labels.replacementAfterMonths')}
      suffix={i18n.t('general.metric.months')}
      onChange={handleChange}
    />
  );
}
